import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

const ManageProductEditForm = ({
  product,
  taxTypes,
  onSubmit,
  onCancel,
  isLoading,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Product Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              defaultValue={product?.name}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Barcode</Form.Label>
            <Form.Control
              type="text"
              name="barcode"
              defaultValue={product?.barcode}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>MRP Amount</Form.Label>
            <Form.Control
              type="text"
              name="mrp_amount"
              defaultValue={product?.mrp?.amount}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>HSN Code</Form.Label>
            <Form.Control
              type="text"
              name="hsn_code"
              defaultValue={product?.hsn_code}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tax Type</Form.Label>
            <Form.Select
              name="tax_type_id"
              defaultValue={product?.tax_type?.id}
            >
              <option value="">Select Tax Type</option>
              {taxTypes.map(taxType => (
                <option key={taxType.id} value={taxType.id}>
                  {taxType.name} ({taxType.tax_rate}%)
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Scan Type</Form.Label>
            <Form.Control
              type="text"
              name="scan_type"
              defaultValue={product?.scan_type}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              name="is_active"
              defaultValue={product?.is_active.toString()}
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Size</Form.Label>
            <Row>
              <Col md={4}>
                <div className="small text-muted mb-1">Width (mm)</div>
                <Form.Control
                  type="text"
                  name="width"
                  defaultValue={product?.width}
                  aria-label="Width"
                />
              </Col>
              <Col md={4}>
                <div className="small text-muted mb-1">Height (mm)</div>
                <Form.Control
                  type="text"
                  name="height"
                  defaultValue={product?.height}
                  aria-label="Height"
                />
              </Col>
              <Col md={4}>
                <div className="small text-muted mb-1">Length (mm)</div>
                <Form.Control
                  type="text"
                  name="length"
                  defaultValue={product?.length}
                  aria-label="Length"
                />
              </Col>
            </Row>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Weight</Form.Label>
            <Row>
              <Col md={8}>
                <div className="small text-muted mb-1">Value</div>
                <Form.Control
                  type="text"
                  name="weight_value"
                  defaultValue={product?.weight?.value}
                  aria-label="Weight Value"
                />
              </Col>
              <Col md={4}>
                <div className="small text-muted mb-1">Unit</div>
                <Form.Select
                  name="weight_unit"
                  defaultValue={product?.weight?.unit}
                  aria-label="Weight Unit"
                >
                  <option value="g">g</option>
                  <option value="kg">kg</option>
                </Form.Select>
              </Col>
            </Row>
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="success" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </Form>
  );
};

export default ManageProductEditForm;
